import { createApi } from "@reduxjs/toolkit/query/react";
import { apiRequestBaseQuery } from "../../services/rtkBaseQuery";
import { getUserDetails } from "../../services/apiRequest";
import { requestType } from "../../services/requests";

// =============================================================================
// ROYAL MOMENTUM - Commercial Performance API
// =============================================================================

export const royalMomentumCommercialPerformanceApi = createApi({
    reducerPath: "royalMomentumCommercialPerformanceApi",
    baseQuery: apiRequestBaseQuery,
    tagTypes: ["WowBookings"],
    endpoints: (builder) => ({
        // =====================================================================
        // WOW BOOKINGS
        // =====================================================================

        // Wow Bookings table (paginated) — V2.
        // `agency_id` replaces `travel_agency_uid`; value is params.travelAgencyUid
        // (= selectedBrand.uid = agency_id_no_r).
        getWowBookings: builder.query({
            query: (params) => ({
                requestType: requestType.getWowBookingsV2,
                data: {
                    user_uid: getUserDetails()?.user_details?.uid,
                    type: params.type || "year",
                    start_date: params.startDate || new Date().getFullYear().toString(),
                    end_date: params.endDate || null,
                    region: params.region === "all" ? null : params.region || null,
                    agency_id: params.travelAgencyUid || null,
                    page: params.page || 1,
                    limit: params.limit || 10,
                },
            }),
            providesTags: ["WowBookings"],
        }),

        // Recent WOW booking (home highlight card) — V2.
        // `agency_id` replaces `travel_agency_uid`; value is params.travelAgencyUid
        // (= selectedBrand.uid = agency_id_no_r).
        getRecentWowBookings: builder.query({
            query: (params) => ({
                requestType: requestType.getRecentWowBookingsV2,
                data: {
                    user_uid: getUserDetails()?.user_details?.uid,
                    agency_id: params.travelAgencyUid || null,
                    region: params.region === "all" ? null : params.region || null,
                },
            }),
            providesTags: ["WowBookings"],
        }),
    }),
});

// Export hooks for usage in components
export const { useGetWowBookingsQuery, useGetRecentWowBookingsQuery } =
    royalMomentumCommercialPerformanceApi;
